import DynamicIcon from "@/components/atoms/DynamicIcon/index";
import useBreakpoint from "@/hooks/useBreakpoint";
import {
  RideIconButton,
  RideGlDown,
} from "@rimac-seguros/ride-system-components";
import React, { useRef, useState } from "react";

const Accordion = ({ label, icon, children, onClick, lastItem }) => {
  const [isOpen, setIsOpen] = useState(false);

  const contentRef = useRef(null);
  const isTablet = useBreakpoint("tablet");

  const handleClick = () => {
    setIsOpen(!isOpen);
    onClick?.(!isOpen);
  };

  return (
    <div className="border-b-ride-gl-border-width-thin border-ride-sys-color-border-default">
      <div
        className="flex items-center justify-between py-ride-gl-spacing-4xlarge gap-ride-gl-spacing-4xlarge lg:py-ride-gl-spacing-6xlarge"
        onClick={handleClick}
      >
        <span className="flex items-center gap-ride-gl-spacing-4xlarge ride-sys-text-title-large-default">
          {isTablet && <DynamicIcon icon={icon} size={"2x-large"} />}
          {label}
        </span>
        <RideIconButton
          glyph={<RideGlDown />}
          size="small"
          variant="unfill"
          aria-label="Icon Button"
          className="transition-all duration-100 ease-linear"
          style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
        />
      </div>
      <div
        ref={contentRef}
        className="overflow-hidden"
        style={{
          height: isOpen ? `${contentRef?.current?.scrollHeight}px` : "0px",
          transition: "height 0.3s ease",
        }}
      >
        <div className="pb-ride-gl-spacing-4xlarge lg:pb-ride-gl-spacing-7xlarge">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
